import type { ReactElement } from 'react';
import { ChatButton, ChatDialogEvent } from 'sdk';

import { useSDK } from '../../../../app';
import { Button } from './button';

export const LinkButton = ({ message, button }: { message: ChatDialogEvent; button: ChatButton }): ReactElement => {
	const { formsStore, conversationsStore } = useSDK();
	return (
		<Button
			disabled={false}
			onClick={(): void => {
				const a = document.createElement('a');
				a.target = '_blank';
				a.rel = 'noreferrer';
				a.href = button.url as string;
				a.click();
				if (!conversationsStore.isLatestConversationResolved) {
					formsStore.sendClickedButton(message.id, button.key);
				}
			}}
			value={button.value}
		/>
	);
};
